import React from 'react';
import { Line } from 'react-chartjs-2';

const EnhancedTrendChart = ({ trendMetrics }) => {
  if (!trendMetrics || !trendMetrics.periodComparisons) {
    return (
      <div className="mt-4 p-4 text-center">
        <h3 className="text-lg font-semibold mb-2">Accuracy Trends</h3>
        <p>No trend metrics data available</p>
      </div>
    );
  }

  const periods = trendMetrics.periodComparisons;
  
  const chartData = {
    labels: periods.map(period => period.periodKey),
    datasets: [
      {
        label: 'Current Period Accuracy',
        data: periods.map(period => period.currentPeriodAccuracy),
        backgroundColor: 'rgba(59, 130, 246, 0.5)',
        borderColor: 'rgb(59, 130, 246)',
        borderWidth: 2,
        tension: 0.1,
      },
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: 'Accuracy (%)'
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            const period = periods[context.dataIndex];
            return [
              `${context.dataset.label}: ${context.parsed.y.toFixed(2)}%`,
              `Trend: ${period.accuracyTrend}`,
              `Change: ${period.trendPercentage > 0 ? '+' : ''}${period.trendPercentage.toFixed(1)}%`
            ];
          }
        }
      },
      legend: {
        display: true
      }
    }
  };

  return (
    <div className="mt-4">
      <h3 className="text-lg font-semibold mb-4">Accuracy Trends</h3>
      
      {/* Trend Summary */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-green-50 p-4 rounded-lg border">
          <div className="text-sm text-gray-600">Consecutive Improving Periods</div>
          <div className="text-2xl font-bold text-green-600">
            {trendMetrics.consecutivePeriodsImproving || 0}
          </div>
        </div>
        <div className="bg-red-50 p-4 rounded-lg border">
          <div className="text-sm text-gray-600">Consecutive Declining Periods</div>
          <div className="text-2xl font-bold text-red-600">
            {trendMetrics.consecutivePeriodsDecline || 0}
          </div>
        </div>
      </div>

      {/* Trend Chart */}
      <div className="h-[400px]">
        <Line data={chartData} options={options} />
      </div>

      {/* Period Details */}
      <div className="mt-4 space-y-2">
        <h4 className="font-medium">Period-over-Period Analysis:</h4>
        <div className="space-y-1 max-h-32 overflow-y-auto">
          {periods.map((period, index) => (
            <div key={index} className="flex items-center justify-between text-sm p-2 bg-gray-50 rounded">
              <span>{period.periodKey}</span>
              <div className="flex items-center gap-2">
                <span>{period.currentPeriodAccuracy.toFixed(1)}%</span>
                <span className={`font-medium ${
                  period.accuracyTrend === 'improving' ? 'text-green-600' : 
                  period.accuracyTrend === 'declining' ? 'text-red-600' : 'text-gray-600'
                }`}>
                  {period.trendPercentage > 0 ? '+' : ''}{period.trendPercentage.toFixed(1)}%
                </span>
                <span className={`text-xs px-2 py-1 rounded ${
                  period.accuracyTrend === 'improving' ? 'bg-green-100 text-green-800' : 
                  period.accuracyTrend === 'declining' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'
                }`}>
                  {period.accuracyTrend}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnhancedTrendChart;